import React, { Fragment, useMemo, useState } from 'react';
import i18n from '../../i18n';
import { NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';

import { logout } from '../../actions/auth';

import { checkRouteAccessibility } from '../../helpers/privileges';

import { SHOWCASE_HOST } from '../../config';
import isMobile from 'ismobilejs';
import { showModal } from '../../actions/modal';
import numeral from 'numeral';
import { getCurrencySymbol } from '../../helpers';
import banner from '../../assets/images/banners/megamarket_200x400.jpg';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';
import LocaleSwitcher from '../Language/LocaleSwitcher';

const Wrapper = styled('div')`
  display: block;
  #sidebar-menu > ul > li > a {
    font-family: 'Roboto', sans-serif;
    display: flex;
  }

  .mobile-sidebar-header {
    display: none;
  }

  .neg {
    color: #f1556c;
    font-weight: 700;
  }
  .pos {
    color: #1aae67;
    font-weight: 700;
  }
  .li-wrap {
    padding: 13px 20px;
  }

  @media (max-width: 1024px) {
    &.hidden {
      display: none;
    }
    top: 0;
    z-index: 101 !important;
    padding-top: 0;

    .mobile-sidebar-header {
      display: flex;
      padding: 20px;
      border-bottom: 1px solid #e3e5e7;
      font-size: 15px;
      margin-bottom: 13px;
    }

    .unreaded-count {
      height: 16px;
      min-width: 16px;
      background-color: red;
      border-radius: 18px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 0 0 10px;
      padding: 0;
      line-height: 1;
      font-size: 10px;
      font-weight: bold;
    }
  }

  .admin-point {
    background-color: #f245d6;

    a {
      color: white !important;
    }
  }

  .visually-hidden {
    display: none;
  }

  .banner-wrap {
    position: relative;
  }

  .banner {
    padding: 0 10px 30px 10px;
  }

  .banner-button {
    position: absolute;
    top: 370px;
    left: 9px;
    padding: 5px 57px;
    color: transparent;
  }
`;

const getShowCaseUrl = (host) => {
  return SHOWCASE_HOST.replace('{{host}}', host);
};

const getCurrentDomain = (domains) => {
  if (domains && domains.length) {
    const external_domain = domains.find((d) => d.external_domain === true);
    if (external_domain) {
      return `http://${external_domain.domain}`;
    }
    const not_auto_generated = domains.find((d) => d.auto_generated === false);
    if (not_auto_generated) {
      return getShowCaseUrl(not_auto_generated.domain);
    }
    const auto_generated = domains.find((d) => d.auto_generated === true);
    if (auto_generated) {
      return getShowCaseUrl(auto_generated.domain);
    }
  }
  return null;
};

//Для открытия админпанели витрины приоритет имеет технический домен. Поскольку при редиректе http->https к привязанным внешним доменам иногда возникает ошибка. А с другой стороны url https не будет работать если к магазину внешний домен вообще не привязан.
const getEditorDomain = (domains) => {
  if (domains && domains.length) {
    const auto_generated = domains.find((d) => d.auto_generated === true);
    if (auto_generated) {
      return getShowCaseUrl(auto_generated.domain);
    }
    const not_auto_generated = domains.find((d) => d.auto_generated === false);
    if (not_auto_generated) {
      return getShowCaseUrl(not_auto_generated.domain);
    }
    const external_domain = domains.find((d) => d.external_domain === true);
    if (external_domain) {
      return `http://${external_domain.domain}`;
    }
  }
  return null;
};

const LinkLi = (props) => {
  const {
    to,
    icon,
    title,
    children,
    childrenElements,
    isOpen,
    toggleElement,
    href,
    target,
    className,
  } = props;

  const LinkContent = () => (
    <>
      {icon && <i className={icon} />}
      <span>{title}</span>
      {childrenElements ? <span className="menu-arrow" onClick={toggleElement} /> : null}
    </>
  );

  return (
    <li className={isOpen ? `${className} active` : `${className}`}>
      {href ? (
        <a href={href} target={target} children={<LinkContent />} />
      ) : (
        <NavLink to={to} target={target} activeClassName="active" children={<LinkContent />} />
      )}
      {children ? (
        <ul className="nav-second-level nav collapse in" aria-expanded="false">
          {children}
        </ul>
      ) : null}
    </li>
  );
};

const handleLogout = (e, logout) => {
  e.preventDefault();
  logout();
};

const getNavigationTree = ({ spareWarehouse, adminPanel, t }) => [
  {
    blockTitle: t('Навигация'),
    elements: [
      // { title: t('Сводка'), to: '/summary', icon: 'fe-activity' },
      {
        title: t('Товары'),
        to: '/items',
        icon: 'fe-tag',
        childrenElements: [
          { title: t('Все товары'), to: '/items' },
          { title: t('Сборка комплектов'), to: '/physical-sets-journal' },
          // { title: t('Коллекции'), to: '/collections' },
          { title: t('Настройка каталога'), to: '/catalog-tuning', hide: true },
          //{title:'Цены',to:'/prices'}
          // { title: t('Отзывы'), to: '/reviews' },
        ],
      },
      {
        title: t('Заказы'),
        to: '/orders',
        icon: 'fe-shopping-cart',
        // childrenElements: [{ title: t('Отгрузки'), to: '/shippings', hide: !spareWarehouse }],
      },
      // {
      //   title: t('Складские документы'),
      //   to: '/documents',
      //   icon: 'fe-file',
      // },
      {
        title: t('Финансы'),
        to: '/finances',
        icon: 'fe-credit-card',
        childrenElements: [
          // { title: 'Тарифы', to: '/pricing-plans' },
          { title: t('Взаиморасчеты'), to: '/finances' },
        ],
      },
      { title: t('Поставки'), to: '/supplies', icon: 'fe-truck' },
      /*      {
        title: 'Фотостудия',
        href: 'https://studio.kak2c.ru/',
        icon: 'fe-camera',
        target: '_blank',
      },*/
      { title: t('Настройки'), to: '/settings', icon: 'fe-settings' },
      {
        title: t('Администрирование'),
        to: '/admin',
        icon: 'fe-user',
        className: adminPanel === 'true' ? 'admin-point' : 'visually-hidden',
      },
    ],
  },
];

const getCurrentPath = (match, navigationTree) => {
  const path = match.path;
  let result = null;
  navigationTree.forEach((block) => {
    block.elements &&
      block.elements.forEach((element) => {
        if (element.to === path) result = element.to;
        element.childrenElements &&
          element.childrenElements.forEach((child) => {
            if (child.to === path) result = element.to;
          });
      });
  });
  return result;
};

const LeftSidebar = (props) => {
  const { auth, match, handleMenuClose, mobileMenuIsOpen, adminPanel } = props;

  const { t } = useAutoTranslation();

  const { account, privileges } = auth;
  const dispatch = useDispatch();

  const spareWarehouse = useSelector((state) =>
    state.orders.warehouses.find((w) => w.operatorType !== 'FULFILLMENT'),
  );
  const navigationTree = getNavigationTree({ spareWarehouse, adminPanel, t });

  const currentPath = getCurrentPath(match, navigationTree);

  const [activeElement, setActiveElement] = useState(currentPath);
  const access_token = useSelector((state) => state.auth.tokenData.access_token);
  const { unreadedCount } = useSelector((state) => state.tickets);

  const toggleElement = (to) => {
    if (to === activeElement) {
      setActiveElement(null);
    } else {
      setActiveElement(to);
    }
  };

  const handleQuestionClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    //ToDo постоянный код
    dispatch(showModal('TicketList', {}));
    /*}*/
  };

  const currentDomain = getCurrentDomain(account.domains);
  const viewSiteUrl = currentDomain ? currentDomain : null;
  const editorDomain = getEditorDomain(account.domains);
  const editorUrl = editorDomain
    ? `${editorDomain}/admin/?login=${account.login}&token=${access_token}`
    : null;

  return useMemo(
    () => (
      <Wrapper className={`left-side-menu ${!mobileMenuIsOpen ? 'hidden' : ''}`}>
        <div className="slimscroll-menu">
          <div id="sidebar-menu">
            <div className="mobile-sidebar-header">
              <i className="fe-x" onClick={handleMenuClose} />
            </div>
            <ul className="metismenu" id="side-menu">
              {navigationTree.map((block, i) => (
                <Fragment key={`block${i}`}>
                  <li className="menu-title">
                    {block.blockTitle} {block.hide}
                  </li>
                  {isMobile().phone && (
                    <li>
                      <div className="li-wrap">
                        Баланс:{' '}
                        <span
                          className={
                            { '-1': `neg`, 0: `default`, 1: `pos` }[
                              Math.sign(account.billingBalance?.total)
                            ]
                          }
                        >{`${numeral(account.billingBalance?.total).format(
                          '0,0.00',
                        )} ${getCurrencySymbol('RUB')}`}</span>
                      </div>
                    </li>
                  )}
                  {isMobile().phone && (
                    <li>
                      <a onClick={handleQuestionClick}>
                        <i className="fe-message-square" />
                        Задать вопрос
                        {unreadedCount ? (
                          <span className="unreaded-count">{unreadedCount}</span>
                        ) : null}
                      </a>
                    </li>
                  )}
                  {block.elements.map((element, ii) =>
                    checkRouteAccessibility(
                      privileges,
                      element.href ? element.href : element.to?.slice(1),
                      account,
                    ) ? (
                      <LinkLi
                        key={`element${ii}`}
                        {...element}
                        isOpen={
                          activeElement === element.to ||
                          (element.exceptions &&
                            element.exceptions.find((e) => e === activeElement))
                        }
                        toggleElement={() => toggleElement(element.to)}
                      >
                        {activeElement === element.to && element.childrenElements
                          ? element.childrenElements.map((child, iii) => (
                              <>
                                {checkRouteAccessibility(privileges, child.to.slice(1), account) ? (
                                  <Fragment key={`child${iii}`}>
                                    {!child.hide ? <LinkLi {...child} /> : null}
                                  </Fragment>
                                ) : null}
                              </>
                            ))
                          : null}
                      </LinkLi>
                    ) : null,
                  )}
                </Fragment>
              ))}
              {/* {(currentDomain && privileges.includes('ADMIN')) ||
              privileges.includes('SHOP_TEMPLATE_READ') ||
              privileges.includes('SHOP_TEMPLATE_WRITE') ? (
                <Fragment>
                  <li className="menu-title" style={{ marginTop: '25px' }}>
                    {t('ИНТЕРНЕТ-МАГАЗИН')}
                  </li>
                  {privileges.includes('ADMIN') || privileges.includes('SHOP_TEMPLATE_READ') ? (
                    <li>
                      <a href={viewSiteUrl} target="_blank" rel="noopener noreferrer">
                        <i className="fe-eye" />
                        <span>{t('Просмотр')}</span>
                      </a>
                    </li>
                  ) : null}
                  {privileges.includes('ADMIN') || privileges.includes('SHOP_TEMPLATE_WRITE') ? (
                    <li>
                      <a href={editorUrl} target="_blank" rel="noopener noreferrer">
                        <i className="fe-edit" />
                        <span>{t('Редактор')}</span>
                      </a>
                    </li>
                  ) : null}
                </Fragment>
              ) : null} */}
              <li style={{ marginTop: '20px' }}>
                <a href="#" onClick={(e) => handleLogout(e, logout)}>
                  <i className="fe-log-out" />
                  <span>{t('Выйти')}</span>
                </a>
              </li>
            </ul>
          </div>

          <div className="clearfix"></div>

          {/* //! МЕСТО ДЛЯ БАННЕРА */}
          {/* <div className="banner-wrap">
            <img className="banner" width="225" src={banner} alt="banner" />
            <a
              className="banner-button"
              href="https://kak2c.ru/services/prodvizhenie-na-marketpleysah/megamarket"
              target="_blank"
              rel="noopener"
            >
              Попробровать
            </a>
          </div> */}
        </div>
      </Wrapper>
    ),
    [privileges, activeElement, mobileMenuIsOpen, adminPanel, t],
  );
};

export default LeftSidebar;
